import { render, staticRenderFns } from "./DeadlineClock.vue?vue&type=template&id=532e745e"
import script from "./DeadlineClock.vue?vue&type=script&lang=js"
export * from "./DeadlineClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports